/* src/app/shared/components/gauge/gauge.component.scss */
.gauge-wrapper {
  display: block;
  width: 100%;
  height: 14px;
  background-color: #AFB1BF;
  border-radius: 2px;
  position: relative;
}
.gauge-wrapper .gauge-progress {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: var(--gauge-width);
  height: 100%;
  background-color: var(--gauge-color);
  border-radius: 2px;
  transition: width 1.5s cubic-bezier(0.68, -0.55, 0.27, 1.25);
}
.gauge-wrapper .gauge-progress:hover::before {
  opacity: 1;
}
.gauge-wrapper .gauge-progress::before {
  content: var(--gauge-value);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 2rem;
  opacity: 0;
  position: absolute;
  top: -1.35rem;
  right: -2.5rem;
  font-size: 0.6em;
  color: #242424;
  transition: opacity 0.3s ease-in-out;
}
.gauge-wrapper .gauge-progress:not(.no-marker)::after {
  content: "";
  display: block;
  width: 1rem;
  height: 1rem;
  background-image: url(/assets/images/gauge-marker.svg);
  background-repeat: no-repeat;
  position: absolute;
  top: -1.1rem;
  right: -0.4rem;
}
.gauge-wrapper .gauge-progress:not(.no-marker).marker-position-bottom::after {
  top: 1.1rem;
  transform: rotatex(180deg);
}
:host(.gauge) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  height: auto;
}
/*# sourceMappingURL=gauge.component.css.map */
